import React from 'react';

interface SectionProps {
  title: string;
  bgColor: string;
  children: React.ReactNode;
  contentClassName?: string;
}

const Section: React.FC<SectionProps> = ({
  title,
  bgColor,
  children,
  contentClassName = 'max-w-4xl mx-auto text-gray-700 text-lg',
}) => {
  return (
    <section className={`${bgColor} px-4 py-12 animate-fade-in-up md:px-8 md:py-20`}>
      <h2 className="text-3xl font-bold text-center mb-8">{title}</h2>
      <div className={contentClassName}>{children}</div>
    </section>
  );
};

export default Section;
